const QUERIES = {
  USERS_LIST: 'users-list',
  TAGS_LIST: 'tags-list',
  TEAMS_LIST: 'teams-list',
  TASKS_LIST: 'tasks-list',
}

export {QUERIES}
